import React from 'react'
import { InputText } from "primereact/inputtext";

import InputWrapper from './InputWrapper';

// Utilities

import { setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function TextInput(props) {
    const {
        formik,
        fieldName,
        isRequired,
        placeholder,
        additionalFunctions,
        isAlphabetic,
        disabled,
        maxLength
    } = props;

    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    return (
        <InputWrapper {...props}>

            <InputText
                id={fieldName}
                name={fieldName}
                value={fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName]}
                // onChange={formik.handleChange(fieldName)}
                onChange={(e) => { 
                    formik.setFieldValue(fieldName, e.target.value); 
                    if (additionalFunctions) { 
                        additionalFunctions() 
                    }
                }}
                onBlur={formik.handleBlur(fieldName)}
                placeholder={placeholder}
                className={`input-field ${error && touched ? 'p-invalid' : ''}`}
                required={isRequired}
                disabled={disabled}
                keyfilter={isAlphabetic ? /^([a-zA-Z\sÑñ]+)$/ : null}
                maxLength={maxLength}
            />

        </InputWrapper>
    )
}

